module.exports = __webpack_public_path__ + "static/Recording_rules_1-0e282009ab9d6a5ab1ce3fbcc51c8d8a.webm";